<template>
  <table class="min-w-full shadow rounded-t-lg overflow-hidden table-background">
    <thead>
      <tr class="">
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          MMA <p class="lowercase">(oz eq)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          GRA <p class="lowercase">(oz eq)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          fru <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          mlk <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          veg <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          dg <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          r/o <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          BPL <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          star <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          oth <p class="lowercase">(cups)</p>
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          Calories (cals)
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          Sodium (mg)
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          Added Sugars (g)
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          Add. Sugar %**
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          Sat. Fat (g)
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          Sat. Fat %**
        </th>
        <th scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          Carbs (g)
        </th>
      </tr>
    </thead>
    <tbody>
      <!-- Odd row -->

      <tr v-if="!sum_products_totals.length" class="bg-white">
        <td class="px-6 py-4 whitespace-nowrap text-base text-color text-center" colspan="17">Calculated totals not
          available!</td>
      </tr>

      <tr v-else-if="form.is_calculation_total_override" class="bg-white">
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"
            
            :value="getValue('MMA')"
          @input="onManualChange($event, 'MMA')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('MMA')]"          
          ></div>
        </td>

        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('WGR')"
          @input="onManualChange($event, 'WGR')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('WGR')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('FRU')"
          @input="onManualChange($event, 'FRU')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('FRU')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('MLK')"
          @input="onManualChange($event, 'MLK')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('MLK')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('VEG')"
          @input="onManualChange($event, 'VEG')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('VEG')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('DG')"
          @input="onManualChange($event, 'DG')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('DG')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('RO')"
          @input="onManualChange($event, 'RO')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('RO')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('BPL')"
          @input="onManualChange($event, 'BPL')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('BPL')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('STAR')"
          @input="onManualChange($event, 'STAR')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('STAR')]"          
          ></div>
        </td>

        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('OTH')"
          @input="onManualChange($event, 'OTH')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('OTH')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('CALS')"
          @input="onManualChange($event, 'CALS')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('CALS')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('SOD')"
          @input="onManualChange($event, 'SOD')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('SOD')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('SUG')"
          @input="onManualChange($event, 'SUG')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('SUG')]"          
          ></div>
        </td>

        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left ">            
            <input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getPercantage(getValue('SUG'), getValue('CALS'), 'cals_percent')"  disabled readonly
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('cals_percent')]"          
          ></div>
        </td>


        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('nutrition_facts_satfat')"
          @input="onManualChange($event, 'nutrition_facts_satfat')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('nutrition_facts_satfat')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            value1="getValue('nutrition_facts_satfat_percent')"
            :value="getPercantage(getValue('nutrition_facts_satfat'), getValue('CALS'), 'sat')"
              disabled readonly
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('nutrition_facts_satfat_percent')]"          
          ></div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div   class="text-left "><input type="number" step="any"   class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24"            
            :value="getValue('CARB')"
          @input="onManualChange($event, 'CARB')"
          :class="['shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm  rounded-md w-24', getBorderClass('CARB')]"          
          ></div>
        </td>        
      </tr>
      <tr v-else v-for="sum_product_total in sum_products_totals" class="bg-white">
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          
          <div v-if="sum_product_total.MMA > 0 && sum_product_total.MMA != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.MMA) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.WGR > 0 && sum_product_total.WGR != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.WGR) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.FRU > 0 && sum_product_total.FRU != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.FRU) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.MLK > 0 && sum_product_total.MLK != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.MLK) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.VEG > 0 && sum_product_total.VEG != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.VEG) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.DG > 0 && sum_product_total.DG != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.DG) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>

        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.RO > 0 && sum_product_total.RO != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.RO) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.BPL > 0 && sum_product_total.BPL != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.BPL) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.STAR > 0 && sum_product_total.STAR != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.STAR) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.OTH > 0 && sum_product_total.OTH != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.OTH) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.CALS > 0 && sum_product_total.CALS != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ nutritionalRounds(sum_product_total.CALS) }} {{ getNull('component_nut_calories') }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> 
          {{ getNull('component_nut_calories') == '*' ? '*' : '-' }}  
          </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.SOD > 0 && sum_product_total.SOD != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ nutritionalRounds(sum_product_total.SOD) }} {{ getNull('component_nut_sodium') }} </div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ getNull('component_nut_sodium') == '*' ? '*' : '-' }}
          </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.SUG > 0 && sum_product_total.SUG != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.SUG) }} {{ getNull('component_nut_added_sugars') }}
          </div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> 
            {{ getNull('component_nut_added_sugars') == '*' ? '*' : '-' }}
           </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.cals_percent > 0 && sum_product_total.cals_percent != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.cals_percent) }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> - </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.nutrition_facts_satfat > 0 && sum_product_total.nutrition_facts_satfat != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ MathOneDecimal(sum_product_total.nutrition_facts_satfat) }} {{ getNull('component_nut_satfat') }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> 
            {{ getNull('component_nut_satfat') == '*' ? '*' : '-' }}
           </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div
            v-if="sum_product_total.nutrition_facts_satfat_percent > 0 && sum_product_total.nutrition_facts_satfat_percent != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.nutrition_facts_satfat_percent) }} </div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> 
            -
          
          </div>
        </td>
        <td scope="col" class="px-3 py-2 text-center text-sm font-white text-black uppercase tracking-wider">
          <div v-if="sum_product_total.CARB > 0 && sum_product_total.CARB != null"
            class="bg-button-color-gray rounded min-w-min-button text-center text-white">
            {{ roundTwoDecimals(sum_product_total.CARB) }}  {{ getNull('component_nut_carbs') }}</div>
          <div v-else class="bg-button-color-gray rounded min-w-min-button text-center text-white"> 
          {{ getNull('component_nut_carbs') == '*' ? '*' : '-' }}  
          </div>
        </td>
      </tr>




      <tr v-if="form.is_calculation_total_override && sum_products_totals.length > 0">
                    <th v-if="getValue('MLK') > 0" scope="col" colspan="3"
                      class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      ADDITIONAL MILK INFO
                    </th>
                    <th v-if="getValue('FRU') > 0 || getValue('VEG') > 0" colspan="2"
                      scope="col" class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      IS THE RECIPE JUICE
                    </th>
                    <th v-if="getValue('WGR') > 0" scope="col" colspan="2"
                      class="px-3 py-3 text-left text-sm font-white text-black uppercase tracking-wider">
                      WHOLE GRAINS INFO
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                    <th scope="col" class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                      &nbsp; &nbsp;&nbsp; &nbsp;
                    </th>
                  </tr>
                  <tr class="bg-white1" v-if="form.is_calculation_total_override && sum_products_totals.length > 0 && (getValue('MLK') > 0 || getValue('FRU') > 0 || getValue('VEG') > 0 || getValue('WGR') > 0)">
                    <th v-if="getValue('MLK') > 0" colspan="3"
                      class="px-3 py-3 text-left text-sm font-bold text-gray-600 align-top">
                      <div class="flex">
                        <div class="relative focus:outline-none W-44 mr-2">
                          <select id="is_the_milk_flavored" name="is_the_milk_flavored"
                            autocomplete="is_the_milk_flavored" v-model="form.is_the_milk_flavored"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Is the Milk Flavored?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>

                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_the_milk_flavored" class="validation_error_msg">{{
                            form.errors.is_the_milk_flavored }}</div>
                        </div>


                        <div class="relative focus:outline-none W-44">
                          <select id="milk_fat_content" name="milk_fat_content" autocomplete="milk_fat_content"
                            v-model="form.milk_fat_content"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Milk Fat Content</option>
                            <option value="Whole Milk">Whole Milk</option>
                            <option value="Reduced Fat 2%">Reduced Fat 2%</option>
                            <option value="Low Fat 1%">Low Fat 1%</option>
                            <option value="Fat-Free / Skim">Fat-Free / Skim</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>

                          <div v-if="form.errors.milk_fat_content" class="validation_error_msg">{{
                            form.errors.milk_fat_content }}</div>
                        </div>

                      </div>
                    </th>
                    <td v-if="(getValue('VEG') > 0) || (getValue('FRU') > 0)" colspan="2"
                      class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 align-top">
                      <div class="flex">
                        <div class="relative focus:outline-none W-44 mr-2">
                          <select id="is_the_recipe_juice" name="is_the_recipe_juice"
                            autocomplete="is_the_recipe_juice" v-model="form.is_the_recipe_juice"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-40 select-menu-height">
                            <option value="">Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_the_recipe_juice" class="validation_error_msg">{{
                            form.errors.is_the_recipe_juice }}</div>
                        </div>                   
                      </div>
                    </td>


                    <td v-if="getValue('WGR') > 0" colspan="2"
                      class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 align-top">
                      <div class="flex">
                        <div class="mr-2 relative focus:outline-none W-44">
                          <select id="is_whole_grains_info" name="is_whole_grains_info"
                            autocomplete="is_whole_grains_info" v-model="form.is_whole_grains_info"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Whole Grain Rich?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>

                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_whole_grains_info" class="validation_error_msg">{{
                            form.errors.is_whole_grains_info }}</div>
                        </div>
                        <div class="relative focus:outline-none W-44">
                          <select id="is_whole_grains_dessert" name="is_whole_grains_dessert"
                            autocomplete="is_whole_grains_dessert" v-model="form.is_whole_grains_dessert"
                            class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-35 select-menu-height">
                            <option value="">Is this a dessert?</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </select>
                          <div
                            class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                            <i class="fa fa-sort-desc" aria-hidden="true"></i>
                          </div>
                          <div v-if="form.errors.is_whole_grains_dessert" class="validation_error_msg">{{
                            form.errors.is_whole_grains_dessert }}</div>
                        </div>
                      </div>
                    </td>

                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center align-top">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-500 text-center flex justify-center ">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                    <td class="px-3 py-3 whitespace-nowrap text-center">
                      &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;
                    </td>
                  </tr>

      

    </tbody>

  </table>
  
</template>

<script>
export default {
  props: ['sum_products_totals', 'form', 'null_nutrient'],
  name: "CalculatedTotalsComponent",
  data() {
    return {
      is_custom: false,
      totals_override: {
        'MMA' : { value: null, original: null, stale: false }
      },
    };
  },

  mounted() {
    // this.setCustomValue();
  },

  methods: {
    
    roundTwoDecimals(result) {
      return this.$helpers.nearestValue(result);
    },
    MathOneDecimal(result) {
      return this.$helpers.MathOneDecimal(result);
    },
    nutritionalRounds(result) {
      // console.log("sum_products_totals", this.sum_products_totals)
      return this.$helpers.nutritionalRounds(result);
    },
    getNull(name) {
      console.log("getNull name", name, this.null_nutrient);
      if(this.null_nutrient.includes(name)){
        return '*';
      } else {
        return '';
      }
    },
    
    getBorderClass (name) {
      if (this.form.is_calculation_total_override && this.form.calculation_total_override?.hasOwnProperty(name)) {
        return 'border-black border-2'
      }
      else {
        return 'border-red-500 border-2'
      }
    },
    
    onManualChange (event, name) {
      if(event.target.value == this.sum_products_totals[0][name]){
        this.$emit('removeCalculationTotalOverride', name);       
      } else {
        this.$emit('setCalculationTotalOverride', name, event.target.value);
      }
      
    },
    getValue(name)
    {
      let total = this.sum_products_totals[0];
      // console.log('getValue total', total);

      if (this.form.is_calculation_total_override && this.form.calculation_total_override?.hasOwnProperty(name)) {
        return this.form.calculation_total_override[name];
      }

      return this.form.is_calculation_total_override 
            ? this.form.calculation_total_override?.[name] ?? total[name] 
            : total[name] ?? null;
    },
    getPercantage(itme, cals, type)
    {
      if(type == 'sat'){
        return this.$helpers.getSatFatPercentage(itme, cals);
      } else {
      return this.$helpers.getCalPercentage(itme, cals);
      }
      
    }
  },


};
</script>

<style></style>
